import { getApiUrl } from '@/lib/api'
import { resolvePlainError, toPlainEnglishError } from '@/lib/plainEnglishErrors'

/**
 * @param {unknown} err
 * @param {string} fallback
 * @returns {string}
 */
export function apiErrorMessage(err, fallback) {
  const axiosErr = /** @type {{ response?: { data?: { message?: string } }; code?: string; message?: string }} */ (
    err
  )

  if (!axiosErr?.response) {
    const code = axiosErr?.code
    const message = axiosErr?.message ?? ''

    if (
      code === 'ERR_NETWORK' ||
      code === 'ECONNABORTED' ||
      message.includes('Network Error') ||
      message.includes('ERR_CONNECTION_REFUSED')
    ) {
      return `Cannot reach the salon server (${getApiUrl()}). Check your internet, or ask your technician to start the app.`
    }

    return toPlainEnglishError(fallback) ?? fallback
  }

  const apiMessage = axiosErr.response.data?.message
  if (typeof apiMessage === 'string') {
    return toPlainEnglishError(apiMessage) ?? apiMessage
  }

  return resolvePlainError(err, fallback)
}
